// extracted by mini-css-extract-plugin
module.exports = {"decoration":"PageLayout_decoration__99874"};